import {cloneDeep as _cloneDeep} from 'lodash';
import LessonModel from "@/models/LessonModel"

const LessonsModule = {
    namespaced: true,
    state: () => ({
        // Список уроків для таблиці
        lessons: [],
        // Поточний урок для форм
        lesson: _cloneDeep(LessonModel),
        // Загальна кількість уроків для пагінації
        lessonsCount: 0,
        // Параметри фільтрації
        filters: {
            search: null,
            course_id: null,
            module_id: null,
            sort_by: 'order',
            sort_dir: 'asc',
            per_page: 30,
            page: 1
        },
        // Медіа уроку
        lessonMedia: [],
        mediaLoading: false,
    }),
    
    getters: {
        getLessons(state) {
            return state.lessons
        },
        getLesson(state) {
            return state.lesson
        },
        getLessonsCount(state) {
            return state.lessonsCount
        },
        getFilters(state) {
            return state.filters
        },
        getLessonMedia(state) {
            return state.lessonMedia
        },
        getMediaLoading(state) {
            return state.mediaLoading
        }
    },
    
    mutations: {
        setLessons(state, payload) {
            state.lessons = payload
        },
        setLesson(state, payload) {
            const base = _cloneDeep(LessonModel)
            state.lesson = { ...base, ...payload }
            if (!state.lesson.content) {
                state.lesson.content = { html: null }
            }
            if (!state.lesson.practical_task) {
                state.lesson.practical_task = { task_text: null, manager_comment: null }
            }
            if (!state.lesson.test) {
                state.lesson.test = {
                    id: null,
                    lesson_id: null,
                    title: '',
                    description: '',
                    questions_limit: null,
                    order_mode: 'ordered',
                    questions: []
                }
            }
        },
        setLessonsCount(state, payload) {
            state.lessonsCount = payload
        },
        setFilters(state, payload) {
            state.filters = { ...state.filters, ...payload }
        },
        resetFilters(state) {
            state.filters = {
                ...state.filters,
                search: null,
                course_id: null,
                module_id: null,
                sort_by: 'order',
                sort_dir: 'asc',
                page: 1
            }
        },
        setLessonMedia(state, payload) {
            state.lessonMedia = payload
        },
        setMediaLoading(state, payload) {
            state.mediaLoading = payload
        },
        addMedia(state, payload) {
            state.lessonMedia.push(payload)
        },
        updateMedia(state, payload) {
            const index = state.lessonMedia.findIndex(m => m.id === payload.id)
            if (index !== -1) {
                state.lessonMedia.splice(index, 1, payload)
            }
        },
        removeMedia(state, id) {
            const index = state.lessonMedia.findIndex(m => m.id === id)
            if (index !== -1) {
                state.lessonMedia.splice(index, 1)
            }
        }
    },
    
    actions: {
        setLessons(context, payload) {
            context.commit('setLessons', payload);
        },
        setLesson(context, payload) {
            context.commit('setLesson', payload);
        },
        setLessonsCount(context, payload) {
            context.commit('setLessonsCount', payload);
        },
        setFilters(context, payload) {
            context.commit('setFilters', payload);
        },
        resetFilters(context) {
            context.commit('resetFilters');
        },
        setLessonMedia(context, payload) {
            context.commit('setLessonMedia', payload);
        },
        setMediaLoading(context, payload) {
            context.commit('setMediaLoading', payload);
        },
        addMedia(context, payload) {
            context.commit('addMedia', payload);
        },
        updateMedia(context, payload) {
            context.commit('updateMedia', payload);
        },
        removeMedia(context, payload) {
            context.commit('removeMedia', payload);
        }
    }
}

export default LessonsModule;
